import { motion } from "framer-motion";
import { HeartPulse, Users, Leaf } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { Reveal, Eyebrow } from "@/components/Reveal";

const ICONS = [HeartPulse, Users, Leaf];

export default function Differentiators() {
  const { t } = useLanguage();

  return (
    <section data-testid="differentiators-section" className="relative py-20 sm:py-28 bg-white grain">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <Reveal>
            <Eyebrow>{t.diff.eyebrow}</Eyebrow>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-4 text-base sm:text-lg text-slate-500">{t.diff.subtitle}</p>
          </Reveal>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6">
          {t.diff.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={item.title}
                data-testid={`diff-card-${i}`}
                initial={{ opacity: 0, y: 36 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
                whileHover={{ y: -6 }}
                className="group relative rounded-3xl border border-slate-200/80 bg-white p-7 shadow-sm hover:shadow-xl hover:border-lime-400/60 transition-[box-shadow,border-color] duration-300"
              >
                <span className="absolute top-6 end-6 font-latin font-extrabold text-4xl text-slate-100 group-hover:text-lime-100 transition-colors select-none">
                  0{i + 1}
                </span>
                <span className="relative w-12 h-12 rounded-2xl bg-lime-50 border border-lime-200 flex items-center justify-center group-hover:bg-lime-500 transition-colors">
                  <Icon size={22} className="text-lime-600 group-hover:text-slate-900 transition-colors" />
                </span>
                <h3 className="relative mt-5 font-display font-semibold text-lg sm:text-xl text-slate-900">{item.title}</h3>
                <p className="relative mt-3 text-sm sm:text-base leading-relaxed text-slate-500">{item.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
